import { render } from "./open-bookings.template.html?vue&type=template&id=0f35f3ce&scoped=true"
import script from "./OpenBookings.vue?vue&type=script&lang=ts"
export * from "./OpenBookings.vue?vue&type=script&lang=ts"

import "./OpenBookings.vue?vue&type=style&index=0&id=0f35f3ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f35f3ce"

export default script